<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
-->
<!-- IP-NOTICE: MIXED -->
<div class="side-menu flex-layout-column flex-layout-align-space-between-start">
	<div class="nav-list-container">
		<mat-nav-list>
			<!-- Main Links -->
			<ng-container>
				<a mat-list-item routerLink="/dashboard" routerLinkActive="menu-link-active"> <mat-icon matListItemIcon>dashboard</mat-icon> Dashboard </a>
				<a mat-list-item routerLink="/configuration/organisers" routerLinkActive="menu-link-active" *ngIf="showInternalOrbitUserOptions">
					<mat-icon matListItemIcon title="Customers">people</mat-icon>
					<div matListItemTitle>Organisers</div>
				</a>
				<a mat-list-item routerLink="/configuration/venues" routerLinkActive="menu-link-active" *ngIf="showInternalOrbitUserOptions">
					<mat-icon matListItemIcon title="Venues">holiday_village</mat-icon>
					<div matListItemTitle>Venues</div>
				</a>
				<a mat-list-item routerLink="/events" routerLinkActive="menu-link-active"
					><mat-icon matListItemIcon title="Events">events</mat-icon>
					<div matListItemTitle>Events</div>
				</a>
				<a mat-list-item routerLink="/orders" [class.menu-link-active]="isOrdersActive()"
					><mat-icon matListItemIcon title="Orders">credit_card</mat-icon>
					<div matListItemTitle>Orders</div>
				</a>
				<a mat-list-item routerLink="/orders/payments-refunds" routerLinkActive="menu-link-active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="showInternalOrbitUserOptions"
					><mat-icon matListItemIcon title="Payments">credit_card</mat-icon>
					<div matListItemTitle>Payments & Refunds</div>
				</a>
				<a mat-list-item routerLink="/customers" routerLinkActive="menu-link-active" *ngIf="showInternalOrbitUserOptions"
					><mat-icon matListItemIcon title="Customers">groups</mat-icon>
					<div matListItemTitle>Customers</div>
				</a>
				<a mat-list-item routerLink="/tickets" routerLinkActive="menu-link-active"
					><mat-icon matListItemIcon title="Tickets">confirmation_number</mat-icon>
					<div matListItemTitle>Tickets</div>
				</a>
			</ng-container>

			<!-- Design -->
			<ng-container>
				<a class="parent-menu-item" mat-list-item>
					<mat-icon matListItemIcon>design_services</mat-icon>
					<div matListItemTitle>Design</div>
				</a>
				<a class="sub-menu" mat-list-item routerLink="/design/booking-confirmation-designs" routerLinkActive="menu-link-active" *ngIf="showInternalOrbitUserOptions"> Booking Confirmation </a>
				<a class="sub-menu" mat-list-item (click)="showNotImplementedFutureSprint($event)" *ngIf="showOrganiserUserOptions"> Booking Confirmation </a>
				<a class="sub-menu" mat-list-item routerLink="/design/e-ticket-designs" routerLinkActive="menu-link-active" *ngIf="showInternalOrbitUserOptions"> eTicket </a>
				<a class="sub-menu" mat-list-item (click)="showNotImplementedFutureSprint($event)" *ngIf="showOrganiserUserOptions"> eTicket </a>
				<a class="sub-menu" mat-list-item routerLink="/design/ticket-shop-designs" routerLinkActive="menu-link-active" *ngIf="showInternalOrbitUserOptions"> Ticket Shop </a>
				<a class="sub-menu" mat-list-item (click)="showNotImplementedFutureSprint($event)" *ngIf="showOrganiserUserOptions"> Ticket Shop </a>
			</ng-container>

			<!-- Configuration -->
			<ng-container *ngIf="showConfigurationMenu">
				<a mat-list-item
					><mat-icon matListItemIcon title="Configuration">settings</mat-icon>
					<div matListItemTitle>Configuration</div>
				</a>
				<a class="sub-menu" mat-list-item routerLink="/configuration/users" routerLinkActive="menu-link-active" *ngIf="showSuperUserOptions">Users</a>
				<a class="sub-menu" mat-list-item routerLink="/configuration/dispatch-methods" routerLinkActive="menu-link-active">Dispatch Methods</a>
				<a class="sub-menu" mat-list-item routerLink="/configuration/orbit-fee-structure" routerLinkActive="menu-link-active">Orbit Fee Structure</a>
				<a class="sub-menu" mat-list-item routerLink="/configuration/ticket-plan-fee-structure" routerLinkActive="menu-link-active">Ticket Plan Fee Structure</a>
			</ng-container>

			<!-- Sandbox -->
			<ng-container *ngIf="showSandboxMenu">
				<a class="parent-menu-item" mat-list-item
					><mat-icon matListItemIcon>science</mat-icon>
					<div matListItemTitle>Sandbox</div>
				</a>
				<a class="sub-menu" mat-list-item routerLink="/sandbox/wallet" routerLinkActive="menu-link-active">Mobile Wallet</a>
				<a class="sub-menu" mat-list-item routerLink="/sandbox/pdfgen" routerLinkActive="menu-link-active">PDF Generation</a>
				<a class="sub-menu" mat-list-item routerLink="/sandbox/active-directory" routerLinkActive="menu-link-active">Active Directory</a>
				<a class="sub-menu" mat-list-item routerLink="/sandbox/region-and-culture" routerLinkActive="menu-link-active">Region & Culture</a>
				<a class="sub-menu" mat-list-item routerLink="/sandbox/payment-integration" routerLinkActive="menu-link-active">Payment Integration</a>
				<a class="sub-menu" mat-list-item routerLink="/sandbox/ticket-shop-preview" routerLinkActive="menu-link-active">Ticket Shop Iframe</a>
			</ng-container>

			<!-- System -->
			<ng-container *ngIf="showSystemMenu">
				<a class="parent-menu-item" mat-list-item
					><mat-icon matListItemIcon>build</mat-icon>
					<div matListItemTitle>System</div>
				</a>
				<a class="sub-menu" mat-list-item *ngIf="showViewDatabaseAudit" routerLink="/configuration/database-audit">Database Audit</a>
				<a class="sub-menu" mat-list-item *ngIf="showSubmitDefect" (click)="submitDefect()">Submit Defect</a>
				<a class="sub-menu" mat-list-item (click)="setTimeProvider()" *ngIf="this.showTimeProvider()"> Current Time <BR /> ({{ currentDatetimeValue() | date: 'dd-MMM-yyyy HH:mm' }}) </a>
			</ng-container>
		</mat-nav-list>
	</div>
	<div class="app-version">Build: {{ appVersion }}</div>
</div>
